import axios from 'axios';

import cfac22 from '../cfac22';

/**
 * Busca a pontuação do usuário no backend Node.
 *
 * @param {string|Object} triiboIdOrParams - Triibo ID ou { triiboId }.
 * @returns {Promise<Object>} Dados do usuário e sua pontuação.
 */
export async function getUserPoints(triiboIdOrParams) {
  const triiboId =
    typeof triiboIdOrParams === 'object'
      ? triiboIdOrParams?.triiboId
      : triiboIdOrParams;

  try {
    const response = await axios.post(
      `${cfac22('API_HOST_V2')}/banks/points/user`,
      { triiboId },
      {
        headers: {
          'Full-Url': window.location.href,
        },
        withCredentials: true,
      }
    );

    return response.data;
  } catch (error) {
    throw error?.response?.data || error;
  }
}
